// extracted by mini-css-extract-plugin
export default {"wrapper":"solution_wrapper__wcwYT","title":"solution_title__TvYj2","des":"solution_des__6qYYR","img_box":"solution_img_box__-wj8p"};